/**
 * afterpay dynamic content
 */

// eslint-disable-next-line require-jsdoc
function stripSpecialChar(val) {
    return val.replace(/[^0-9.]/g, '');
}

var afterpayPriceTableFunction = function () {
    let cartTotalEl = '.text-right.grand-total-sum.estimated-cost';
    let checkoutTotal = '.grand-total-sum.order-cost-item-value.estimated_total';
    let checkoutTotalMob = '.grand-total-price.grand-total-sum.order-cost-item-value.estimated_total';
    let prodPageCost = '.page.current.product .price.ds-product-price span.value';
    let price = null;
    let pdpAddToCart = '.add-to-cart-container button.add-to-cart';

    

    // eslint-disable-next-line require-jsdoc
    function updateAfterPay(element) {
        var target = $(element)[0];
        var observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                var newNodes = mutation.addedNodes;
                if (newNodes !== null && newNodes.length > 0) {
                    var newNodeText = newNodes[0].textContent;
                    if (!newNodeText.toLowerCase().includes('adding')) {
                        price = stripSpecialChar(newNodeText);
                        if (isNaN(price)) {
                            price = '0';
                        }
                        $('afterpay-placement').attr('data-amount', price);
                    }
                }
            });
        });

        var config = {
            childList: true
        };

        if (target) {
            observer.observe(target, config);
        }
    } // end mutation observer function

    if ($('.page.current.cart').length) {
        price = (stripSpecialChar($(cartTotalEl).eq(0).text()));
    } else if ($('.page.current.product').length) {
        if ($(pdpAddToCart).data('israngeprice')) {
            /**
             * pdp page - no product varient selected
             * passing zero product price to afterpay as product varient has different prices
             * condition for displaying standard msg from after pay
             */
            price = '0';
        } else {
            price = (stripSpecialChar(utag_data.product_price_actual[0]));
        }
    } else if ($('.page.checkout').length) {
        price = (stripSpecialChar($(checkoutTotal).eq(0).text()));
    }

    $('afterpay-placement').attr('data-amount', price);

    if ($(checkoutTotalMob).length) {
        updateAfterPay(checkoutTotalMob);
    } else if ($(checkoutTotal).length) {
        updateAfterPay(checkoutTotal);
    } else if ($(pdpAddToCart).length) {
        updateAfterPay(pdpAddToCart);
    } else if ($(prodPageCost).length) {
        updateAfterPay(prodPageCost);
    } else {
        updateAfterPay(cartTotalEl);
    }
};

$(document).ready(function () {
    afterpayPriceTableFunction();
});

$('body').on('productSet:quickview', function () {
    if ($(".product-set-detail").length) {
        let quickviewSetPrice = $('.quickview-set .ds-product-price .sales .value');
        let price = stripSpecialChar(quickviewSetPrice[0].textContent);
        if (isNaN(price)) {
            price = '0';
        }
        $('afterpay-placement').attr('data-amount', price);
        $('.quickview__modal__body--contentassets .afterpay-container').removeClass('invisible');
    }
});